import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "sp-pay-before",
  "data-testid": "sp-pay-before"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioGroup = _resolveComponent("RadioGroup")!
  const _component_CustomerioBanner = _resolveComponent("CustomerioBanner")!
  const _component_V1ScreenScaffold = _resolveComponent("V1ScreenScaffold")!

  return (_openBlock(), _createBlock(_component_V1ScreenScaffold, {
    title: _ctx.t('InstallmentsList-Title'),
    "next-disabled": !_ctx.canContinue,
    "data-testid": "sp-installments",
    onNext: _ctx.handleContinue
  }, _createSlots({
    default: _withCtx(() => [
      _createVNode(_component_RadioGroup, {
        "model-value": _ctx.selectedValue,
        options: _ctx.options,
        "aria-label": _ctx.t('InstallmentsList-Title'),
        "data-testid": "sp-options",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedValue = String($event)))
      }, null, 8, ["model-value", "options", "aria-label"]),
      _createVNode(_component_CustomerioBanner)
    ]),
    _: 2
  }, [
    (_ctx.payBeforeDate)
      ? {
          name: "subtitle",
          fn: _withCtx(() => [
            _createElementVNode("p", _hoisted_1, [
              (_ctx.payBeforeDate.isOverdue)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.payBeforeDatePrefix), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.t("pay-before")), 1)),
              _createTextVNode(" " + _toDisplayString(_ctx.payBeforeDate.datetime), 1)
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["title", "next-disabled", "onNext"]))
}